import { type EventCategory, EventDefinitions, type EventName } from '@/lib/tracking/types';

// Marketing events (the landing page events) go through posthog-js only, so they wait for
// cookie consent and carry the page URL, referrer and campaign params.
export function isMarketingEvent(event: EventName): boolean {
  const categories: readonly EventCategory[] = EventDefinitions[event].categories;
  return categories.includes('marketing');
}
